import React, { useState } from 'react'
import {
    FormControl,
    MenuItem,
    Select,
    TextField,
    Grid,
    useMediaQuery,
    InputLabel
} from '@mui/material'
import { makeStyles } from '@mui/styles'

import inviteActions from './actions'
import { useSelector } from 'react-redux'
import { UserRole, UserRoleText } from 'pages/User/constants'
import { INVITE_PROP } from './constants'
const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: '100%',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    formControls: {
        minWidth: '320px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    formControlItem: {
        minWidth: '320px',
    },
}))

const InvitesFilterBar = () => {
    const classes = useStyles()
    const { search } = useSelector((state) => state.invites.table)
    const [role, setRole] = useState('ALL')
    const { setFilter, setSearch, setPageOffset } = inviteActions()
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    return (
        <Grid container style={{ margin: '20px 0' }}>
            <Grid
                item
                container
                justify="flex-start"
                alignContent="center"
                xs={12}
                lg={7}
            >
                <FormControl variant="outlined" className={classes.formControl}>
                    <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => {
                            setPageOffset(0)
                            setSearch(e.target.value)
                        }}
                    />
                </FormControl>
            </Grid>
            {matches && <Grid item lg={1} />}
            <Grid
                item
                container
                justify="flex-start"
                alignContent="center"
                xs={8}
                lg={4}
            >
                <FormControl
                    size="small"
                    variant="outlined"
                    className={classes.formControls}
                >
                    <InputLabel id="role-select-label" sx={{margin:'-8px'}}>Role</InputLabel>
                    <Select
                        className={classes.formControls}
                        value={role}
                        id="role-select"
                        onChange={(e) => {
                            if (e.target.value !== 'ALL') {
                                setFilter([
                                    {
                                        col: INVITE_PROP.ROLE,
                                        op: 'eq',
                                        val: e.target.value,
                                    },
                                ])
                            } else {
                                setFilter([])
                            }
                            setPageOffset(0)
                            setRole(e.target.value)
                        }}
                        autoWidth
                    >
                        <MenuItem
                            className={classes.formControlItem}
                            value="ALL"
                            key="ALL"
                        >
                            All
                        </MenuItem>
                        {Object.keys(UserRole).map((x) => {
                            return (
                                <MenuItem
                                    className={classes.formControlItem}
                                    value={UserRole[x]}
                                    key={x}
                                >
                                    {UserRoleText[UserRole[x]]}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    )
}

export default InvitesFilterBar
